import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useTypedSelector} from "helpers/reducers";
import {Link} from "react-router-dom";
import {UserIcon} from "@heroicons/react/24/outline";

interface BookingLoginButtonNewProps {
    className?: string;
}

const BookingLoginButtonNew = (props: BookingLoginButtonNewProps) => {
    const {t} = useTranslation();
    const [hasCustomerSession, setHasCustomerSession] = useState<boolean>(false);

    const reservations = useTypedSelector(state => state.bookingLoginState.reservations);
    const session = useTypedSelector(state => state.sessionState.session);

    const loginPath = reservations.length === 0 ? "/booking/login" : "/booking/login/reservations";


    const getLoginPath = () => {
        if (hasCustomerSession) {
            return "/booking/login/reservations";
        }
        return "/booking/login";
    };

    useEffect(() => {
        if (session && (session.user.user_type !== "visitor" && session.user.user_type !== "guest") ) {
            setHasCustomerSession(true);
        } else {
            setHasCustomerSession(false);
        }
    }, [session]);

    return (
        <Link
            className={
                "group border-[1px] border-[#EEEEEE] inline-flex items-center rounded-full bg-[#EEEEEE] hover:bg-arbo-orange/5"
            }
            to={loginPath}
        >
            <span className="inline-flex items-center justify-center rounded-full overflow-hidden pt-[4px]">
                <UserIcon className={"flex-none -mb-[4px] size-[28px] text-[#3E52C7] group-hover:text-arbo-orange"} />
            </span>
        </Link>
    );
};

export default BookingLoginButtonNew;